import { render, staticRenderFns } from "./voiceOfTheCustomer.vue?vue&type=template&id=73f4d296&scoped=true"
import script from "./voiceOfTheCustomer.vue?vue&type=script&lang=js"
export * from "./voiceOfTheCustomer.vue?vue&type=script&lang=js"
import style0 from "./voiceOfTheCustomer.vue?vue&type=style&index=0&id=73f4d296&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4d296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f4d296')) {
      api.createRecord('73f4d296', component.options)
    } else {
      api.reload('73f4d296', component.options)
    }
    module.hot.accept("./voiceOfTheCustomer.vue?vue&type=template&id=73f4d296&scoped=true", function () {
      api.rerender('73f4d296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/voiceOfTheCustomer.vue"
export default component.exports